import * as React from "react";

function SvgUserGroupDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M13.839 12.149a4.25 4.25 0 014.25 4.25V20a.75.75 0 01-.75.75H6.66a.75.75 0 01-.75-.75v-3.601a4.25 4.25 0 014.25-4.25zm6.661 1.505a3.25 3.25 0 013.245 3.066l.005.184V18a.75.75 0 01-1.493.102L22.25 18v-1.096a1.75 1.75 0 00-1.606-1.744l-.144-.006h-.801a.75.75 0 01-.102-1.493l.102-.007h.801zm-16.199 0a.75.75 0 01.102 1.493l-.102.007H3.5a1.75 1.75 0 00-1.744 1.606l-.006.144V18a.75.75 0 01-1.493.102L.25 18v-1.096a3.25 3.25 0 013.066-3.245l.184-.005h.801zm17.022-5.66a2.77 2.77 0 010 3.92 2.772 2.772 0 01-3.922 0 2.77 2.77 0 010-3.92 2.772 2.772 0 013.922 0zm-14.724 0a2.77 2.77 0 010 3.92 2.772 2.772 0 01-3.922 0A2.774 2.774 0 016.6 7.993zm11.863 1.06a1.273 1.273 0 101.893.103l-.093-.103-.103-.093a1.273 1.273 0 00-1.697.093zm-14.724 0a1.273 1.273 0 101.893.103l-.093-.103-.103-.093a1.273 1.273 0 00-1.697.093zm10.995-4.672a3.864 3.864 0 010 5.466 3.864 3.864 0 01-5.466 0 3.864 3.864 0 010-5.466 3.864 3.864 0 015.466 0z"
        />
        <path
          fill="#98DB69"
          d="M13.839 13.649l.168.005a2.75 2.75 0 012.582 2.745l-.001 2.85H7.409l.001-2.85a2.75 2.75 0 012.75-2.75h3.679zm-3.511-8.206a2.364 2.364 0 013.215-.12l.13.12.12.13a2.365 2.365 0 11-3.465-.13z"
        />
      </g>
    </svg>
  );
}

export default SvgUserGroupDuo;
